export const REPLACE_REPORT_DATA = 'REPLACE_REPORT_DATA';
export const REPORT_PATCH_PROPERTIES = 'REPORT_PATCH_PROPERTIES';
export const REPORT_DELETE_REPORT_DATA = 'REPORT_DELETE_REPORT_DATA';
export const REPLACE_FILTER_TEMPLATES = 'REPLACE_FILTER_TEMPLATES';
export const REPORT_PATCH_IS_FETCHING_DATA = 'REPORT_PATCH_IS_FETCHING_DATA';
